<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Inspecciones</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item activex">Administrativo</li>
                  <li class="breadcrumb-item active">Operación</li>
                  <li class="breadcrumb-item active">Central Tráfico</li>
                  <li class="breadcrumb-item active">Inspecciones</li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <div class="card">
              <div class="col-6 pt-2 pb-2">
                <h5>Inspecciones</h5>
              </div>
              <ul id="myTab" role="tablist" class="nav nav-tabs">
                <li class="nav-item">
                  <a
                    id="tab-Principal"
                    data-toggle="tab"
                    href="#Principal"
                    class="nav-link active"
                    @click="cambiaTab('principal')"
                    >Principal</a
                  >
                </li>
                <li class="nav-item">
                  <a
                    id="tab-Gestion"
                    data-toggle="tab"
                    href="#Gestion"
                    class="nav-link"
                    @click="cambiaTab('gestiona')"
                    v-if="form.id"
                    >Gestionar Inspección</a
                  >
                </li>
                <li class="nav-item">
                  <a
                    id="tab-Gestion"
                    data-toggle="tab"
                    href="#Documentos"
                    class="nav-link"
                    @click="cambiaTab('documentos')"
                    v-if="
                      form.id &&
                      (form.conductor_id ||
                        form.vehiculo_id ||
                        form.remolque_id)
                    "
                    >Documentos</a
                  >
                </li>
              </ul>
              <div id="myTabContent" class="tab-content">
                <!-- Formulario -->
                <div id="Principal" class="tab-pane fade active show">
                  <div class="card-body">
                    <div class="row">
                      <div class="form-group col-md-1">
                        <label>Viaje id</label>
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          v-model="form.viaje_id"
                          readonly
                        />
                      </div>
                      <div class="form-group col-md-2 text-center">
                        <label>Pre-operacional</label>
                        <input
                          type="checkbox"
                          class="form-control form-control-sm p-0"
                          v-model="form.preoperacional"
                          :disabled="form.formato_inspeccion_id"
                          @click="
                            formato_inspeccion == null &&
                              (form.formato_inspeccion_id = null)
                          "
                        />
                      </div>
                      <div class="col-md-2">
                        <label>Tipo de sitio:</label>
                        <select
                          class="form-control form-control-sm"
                          v-model="form.sitio_type"
                          @input="form.sitio_id = null && (sitio = {})"
                        >
                          <option
                            v-for="tipo in listasForms.sitio_types"
                            :key="tipo.numeracion"
                            :value="tipo.numeracion"
                          >
                            {{ tipo.descripcion }}
                          </option>
                        </select>
                      </div>
                      <div
                        class="form-group col-md-3"
                        v-if="form.sitio_type == 2"
                      >
                        <label>Punto de Gestión</label>
                        <v-select
                          :class="
                            $store.getters.getDarkMode ? 'dark-vselect' : ''
                          "
                          v-model="sitio"
                          placeholder="Punto Gestión"
                          label="nombre"
                          :options="listasForms.puntos_gestion"
                          @input="selectSitio"
                        ></v-select>
                      </div>
                      <div
                        class="form-group col-md-3"
                        v-if="form.sitio_type == 1"
                      >
                        <label>Sitio</label>
                        <v-select
                          :class="
                            $store.getters.getDarkMode ? 'dark-vselect' : ''
                          "
                          v-model="sitio"
                          placeholder="Sitio"
                          label="nombre"
                          :options="listasForms.sitios"
                          @input="selectSitio"
                        ></v-select>
                      </div>
                      <div class="form-group col-md-4">
                        <label>Formato de Inspección</label>
                        <v-select
                          :class="[
                            $v.form.formato_inspeccion_id.$invalid
                              ? 'is-invalid'
                              : 'is-valid',
                            $store.getters.getDarkMode ? 'dark-vselect' : '',
                          ]"
                          v-model="formato_inspeccion"
                          placeholder="Formato Inspección"
                          label="nombre"
                          class="form-control form-control-sm p-0"
                          :options="listasForms.formatos_inspeccion"
                          @search="buscarFormatosInspeccion"
                          @input="selectFormatoInspeccion"
                        ></v-select>
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-md-2">
                        <label>Cabezote</label>
                        <v-select
                          :class="[
                            $v.form.vehiculo_id.$invalid
                              ? 'is-invalid'
                              : 'is-valid',
                            $store.getters.getDarkMode ? 'dark-vselect' : '',
                          ]"
                          v-model="vehiculo"
                          placeholder="Placa"
                          label="placa"
                          class="form-control form-control-sm p-0"
                          :options="listasForms.vehiculos"
                          @search="buscarVehiculos"
                          @input="selectVehiculo"
                        ></v-select>
                        <div v-if="form.vehiculo_id">
                          <div
                            v-if="
                              vehiculo.ultimo_registro &&
                              vehiculo.ultimo_registro != ''
                            "
                          >
                            <span
                              class="badge badge-warning"
                              v-if="
                                vehiculo.ultimo_registro
                                  .fecha_hora_ultimo_reporte < fechaCorte
                              "
                            >
                              Ultimo reporte:
                              {{
                                vehiculo.ultimo_registro
                                  .fecha_hora_ultimo_reporte
                              }}
                            </span>
                            <span class="badge badge-success" v-else>
                              Ultimo reporte:
                              {{
                                vehiculo.ultimo_registro
                                  .fecha_hora_ultimo_reporte
                              }}
                            </span>
                          </div>
                          <div v-else>
                            <span class="badge badge-danger"
                              >No presenta fecha de reporte</span
                            >
                          </div>
                        </div>
                      </div>
                      <div class="form-group col-md-2">
                        <label>Remolque</label>
                        <v-select
                          :class="[
                            $v.form.remolque_id.$invalid
                              ? 'is-invalid'
                              : 'is-valid',
                            $store.getters.getDarkMode ? 'dark-vselect' : '',
                          ]"
                          v-model="remolque"
                          placeholder="Placa"
                          label="placa"
                          class="form-control form-control-sm p-0"
                          :options="listasForms.remolques"
                          @search="buscarRemolques"
                        ></v-select>
                      </div>
                      <div class="form-group col-md-4">
                        <label>Empresa</label>
                        <v-select
                          :class="[
                            $v.form.empresa_id.$invalid
                              ? 'is-invalid'
                              : 'is-valid',
                            $store.getters.getDarkMode ? 'dark-vselect' : '',
                          ]"
                          v-model="empresa"
                          placeholder="Empresa"
                          label="razon_social"
                          class="form-control form-control-sm p-0"
                          :options="listasForms.empresas"
                          @search="buscarEmpresas"
                          @input="selectEmpresa"
                        ></v-select>
                      </div>
                      <div class="form-group col-md-4">
                        <label>Conductor</label>
                        <v-select
                          :class="[
                            $v.form.conductor_id.$invalid
                              ? 'is-invalid'
                              : 'is-valid',
                            $store.getters.getDarkMode ? 'dark-vselect' : '',
                          ]"
                          v-model="conductor"
                          placeholder="Conductor"
                          label="nombre"
                          class="form-control form-control-sm p-0"
                          :options="listasForms.conductores"
                          @input="selectConductor"
                          @search="buscarConductor"
                        ></v-select>
                      </div>
                    </div>
                    <!-- <div class="row" v-if="viaje && cabezote">
                      <div class="form-group col-md-4">
                        <label>Sitio Cargue</label>
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          :value="viaje.cargue"
                          readonly
                        />
                      </div>
                      <div class="form-group col-md-4">
                        <label>Sitio Desargue</label>
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          :value="viaje.descargue"
                          readonly
                        />
                      </div>
                    </div> -->
                    <div class="row">
                      <div class="form-group col-md-3">
                        <label for="fecha_inicio">Fecha Inicial</label>
                        <input
                          type="date"
                          class="form-control form-control-sm"
                          v-model="form.fecha_inicio"
                          readonly
                        />
                      </div>
                      <div class="form-group col-md-3">
                        <label for="hora_inicio">Hora Inicial</label>
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          v-model="form.hora_inicio"
                          v-mask="{
                            mask: '99:99',
                            hourFormat: '24',
                          }"
                          readonly
                        />
                      </div>
                      <div class="form-group col-md-3">
                        <label for="fecha_fin">Fecha Final</label>
                        <input
                          type="date"
                          class="form-control form-control-sm"
                          v-model="form.fecha_fin"
                          readonly
                        />
                      </div>
                      <div class="form-group col-md-3">
                        <label for="hora_fin">Hora Final</label>
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          v-model="form.hora_fin"
                          v-mask="{
                            mask: '99:99',
                            hourFormat: '24',
                          }"
                          readonly
                        />
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-md-3">
                        <label>Responsable</label>
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          :value="responsable.nombre"
                          readonly
                        />
                        <input
                          v-model="form.responsable_id"
                          type="hidden"
                          class="form-control form-control-sm p-0"
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label>Observaciones</label><br /><textarea
                          vtype="date"
                          rows="2"
                          class="form-control form-control-sm"
                          v-model="form.observaciones"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Gestión de inspecciones -->
                <div
                  id="Gestion"
                  class="tab-pane fade"
                  v-if="form.id && formato_inspeccion"
                >
                  <InspeccionGestiona
                    ref="InspeccionGestiona"
                  ></InspeccionGestiona>
                  <InspeccionImages ref="inspeccionImages"></InspeccionImages>
                </div>
                <!-- Documentos -->
                <div id="Documentos" class="tab-pane fade" v-if="form.id">
                  <InspeccionDocumentos
                    ref="InspeccionDocumentos"
                  ></InspeccionDocumentos>
                </div>
              </div>
              <div class="card-footer">
                <div class="row justify-content-center">
                  <div class="col-md-4">
                    <button class="btn btn-lg bg-secondary" @click="back()">
                      <i class="fas fa-reply"></i> Volver
                    </button>
                    <button
                      class="btn btn-lg bg-navy"
                      @click="centralTraficoBack()"
                    >
                      <i class="fas fa-reply"></i> Central Trafico
                    </button>
                    <button class="btn btn-lg bg-primary" @click="save">
                      <!-- v-show="
                        ($store.getters.can(
                          'hidrocarburos.inspecciones.edit'
                        ) ||
                          (viajeInspeccion &&
                            viajeInspeccion.val_inspeccion != null)) &&
                        !$v.form.$invalid &&
                        tab == 'principal' &&
                        (estado_documento == 1 || estado_documento == null)
                      " -->
                      <i class="fas fa-paper-plane"></i>Guardar
                    </button>
                    <button
                      class="btn btn-lg bg-primary"
                      v-if="
                        $store.getters.can('hidrocarburos.inspecciones.edit') &&
                        estado_documento == 1 &&
                        tab == 'gestiona' &&
                        $refs.InspeccionGestiona.flagGestionado
                      "
                      @click="$refs.InspeccionGestiona.save()"
                    >
                      <i class="fas fa-paper-plane"></i><br />Guardar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import vSelect from "vue-select";
import Loading from "../../../../../components/Loading";
import { required, helpers } from "vuelidate/lib/validators";
import InspeccionImages from "../../../../hidrocarburos/basico/inspecciones/InspeccionImages.vue";
import InspeccionGestiona from "../../../../hidrocarburos/basico/inspecciones/InspeccionGestiona.vue";
import InspeccionDocumentos from "../../../../hidrocarburos/basico/inspecciones/InspeccionDocumentos.vue";
const timeFormat = helpers.regex(
  "timeFormat",
  /^([0-1]?[0-9]|2[0-3]):([0-5][0-9])(:[0-5][0-9])?$/
);
export default {
  name: "CentralTraficoInspeccionForm",
  components: {
    Loading,
    vSelect,
    InspeccionImages,
    InspeccionGestiona,
    InspeccionDocumentos,
  },
  data() {
    return {
      cargando: false,
      tab: "principal",
      responsable: {
        id: this.$store.getters.getUser.id,
        nombre: this.$store.getters.getUser.name,
      },
      formato_inspeccion: null,
      fechaActual: null,
      fechaCorte: null,
      estado: null,
      estado_documento: null,
      viajeInspeccion: null,
      entidad: null,
      inspeccion: null,
      vehiculo: {},
      remolque: {},
      empresa: {},
      conductor: {},
      sitio: {},
      form: {
        id: null,
        det_postulacion_id: null,
        viaje_id: null,
        sitio_id: null,
        sitio_type: null,
        formato_inspeccion_id: null,
        vehiculo_id: null,
        remolque_id: null,
        empresa_id: null,
        conductor_id: null,
      },
      listasForms: {
        sitio_types: [],
        puntos_gestion: [],
        formatos_inspeccion: [],
        empresas: [],
        conductores: [],
        cabezotes: [],
        remolques: [],
      },
    };
  },
  validations() {
    let remol = {};
    if (this.cabezote?.tipo_vehiculo_id == 1) {
      remol = {
        required,
      };
    } else {
      remol = {
        required: false,
      };
    }

    return {
      form: {
        formato_inspeccion_id: {
          required,
        },
        vehiculo_id: {
          required,
        },
        remolque_id: remol,
        empresa_id: {
          required,
        },
        conductor_id: {
          required,
        },
      },
    };
  },
  methods: {
    async getIndex() {
      this.viajeInspeccion = this.$route.params.viaje;

      if (this.viajeInspeccion !== undefined) {
        this.form.preoperacional = this.$route.params.preoperacional;
        this.formato_inspeccion = this.$route.params.formato_inspeccion;
        this.entidad = this.viajeInspeccion.det_solicitud_diaria
          ? "Postulacion"
          : "Viaje";
        this.vehiculo = this.viajeInspeccion.vehiculo;
        this.empresa = this.viajeInspeccion.transportadora
          ? this.viajeInspeccion.transportadora
          : this.viajeInspeccion.det_solicitud_diaria.empresa;
        this.conductor =
          this.viajeInspeccion.conductor.nombres +
          " " +
          this.viajeInspeccion.conductor.apellidos;
        this.remolque = this.viajeInspeccion.remolque
          ? this.viajeInspeccion.remolque
          : {};
        this.form.viaje_id = this.viajeInspeccion.id;
        this.form.vehiculo_id = this.viajeInspeccion.vehiculo_id;
        this.form.empresa_id = this.viajeInspeccion.transportadora
          ? this.viajeInspeccion.transportadora_id
          : this.viajeInspeccion.det_solicitud_diaria.empresa.id;
        this.form.conductor_id = this.viajeInspeccion.conductor_id;
        this.form.remolque_id = this.viajeInspeccion.remolque_id
          ? this.viajeInspeccion.remolque_id
          : null;
        this.form.formato_inspeccion_id = this.formato_inspeccion.id;
        this.form.sitio_type =
          this.$route.params.sitio_type == "App\\Sitio" ? 1 : 2;
        this.form.sitio_id = this.viajeInspeccion.sitio_id
          ? this.viajeInspeccion.sitio_id
          : this.viajeInspeccion.det_solicitud_diaria.solicitud_diaria.sitio_id;
        this.sitio = this.viajeInspeccion.sitio
          ? this.viajeInspeccion.sitio
          : this.viajeInspeccion.det_solicitud_diaria.solicitud_diaria.sitio;
      }
    },

    getSitioType() {
      // sitio 1, punto gestion 2
      axios.get("/api/lista/25").then((response) => {
        this.listasForms.sitio_types = response.data;
      });
    },

    selectSitio() {
      if (this.form.sitio_type) {
        if (this.sitio) {
          this.form.sitio_id = this.sitio.id;
        }
      }
    },

    selectFormatoInspeccion() {
      if (this.formato_inspeccion) {
        this.form.formato_inspeccion_id = this.formato_inspeccion.id;
      }
    },

    selectConductor() {
      if (this.conductor) {
        this.form.conductor_id = this.conductor.id;
      }
    },

    selectVehiculo() {
      if (this.vehiculo) {
        this.form.vehiculo_id = this.vehiculo.id;
      }
    },

    selectRemolque() {
      if (this.remolque) {
        this.form.remolque_id = this.remolque.id;
      }
    },

    selectEmpresa() {
      if (this.empresa) {
        this.form.empresa_id = this.empresa.id;
      }
    },

    // Métodos para busqueda del formulario
    buscarSitios() {
      let me = this;
      me.cargando = true;
      var url = "/api/admin/sitios/lista";
      axios
        .get(url, {
          params: {
            estado: 1,
          },
        })
        .then(function (response) {
          let respuesta = response.data;
          me.listasForms.sitios = respuesta;
          me.cargando = false;
        })
        .catch(function (error) {
          me.cargando = false;
          this.$swal({
            icon: "error",
            title: "Ocurrió un error: " + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    buscarPuntosGestion() {
      let me = this;
      me.cargando = true;
      var url = "/api/admin/puntos_gestion/lista";
      axios
        .get(url, {
          params: {
            estado: 1,
          },
        })
        .then(function (response) {
          let respuesta = response.data;
          me.listasForms.puntos_gestion = respuesta;
          me.cargando = false;
        })
        .catch(function (error) {
          me.cargando = false;
          this.$swal({
            icon: "error",
            title: "Ocurrió un error: " + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    buscarFormatosInspeccion(search, loading) {
      if (search != "") {
        // Pregunto si es preoperacional
        let sitio = null;
        let sitio_type = null;
        let pre_operacional = 0;
        let params = null;
        let tipo_operacion = 0;

        if (this.preoperacional) {
          pre_operacional = 1;
        } else {
          if (this.sitio) {
            sitio = this.sitio.id;
            sitio_type = this.form.sitio_type;
          }
        }

        if (this.formato_inspeccion) {
          tipo_operacion = this.formato_inspeccion.tipo_operacion;
          params = {
            sitio,
            sitio_type,
            pre_operacional,
            tipo_operacion,
          };
        } else {
          params = {
            sitio,
            sitio_type,
            pre_operacional,
          };
        }
        let me = this;
        me.cargando = true;

        loading(true);
        var url =
          "/api/hidrocarburos/inspecciones/buscarformatosinspeccion?nombre=" +
          search;

        axios
          .get(url, { params })
          .then(function (response) {
            me.listasForms.formatos_inspeccion = response.data;
            me.cargando = false;
            loading(false);
          })
          .catch(function (error) {
            me.cargando = false;
            this.$swal({
              icon: "error",
              title: "Ocurrió un error: " + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    buscarVehiculos(search, loading) {
      this.fechaActual = moment().format("YYYY-MM-DD HH:mm:ss");
      this.fechaCorte = moment(this.fechaActual)
        .add(-2, "hours")
        .format("YYYY-MM-DD HH:mm:ss");
      if (search != "") {
        let operacion = 0;
        if (this.preoperacional) {
          operacion = 1;
        }
        let me = this;
        me.cargando = true;

        loading(true);
        var url =
          "/api/hidrocarburos/inspecciones/buscarcabezote?placa=" + search;
        axios
          .get(url, {
            params: {
              operacion,
            },
          })
          .then(function (response) {
            me.listasForms.cabezotes = response.data;
            me.cargando = false;
            loading(false);
          })
          .catch(function (error) {
            me.cargando = false;
            this.$swal({
              icon: "error",
              title: "Ocurrió un error: " + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    validaRemolque() {
      if (!this.form.cabezote || this.form.cabezote.tipo_vehiculo_id != 1) {
        this.form.remolque = null;
      } else if (this.form.cabezote.viajes) {
        this.form.viaje_id = this.form.cabezote.viajes.id;
        // Se llenan los datos del viaje
        this.viaje = {
          sitio_origen: this.form.cabezote.viajes.det_guia.sitio_origen.nombre,
          sitio_destino:
            this.form.cabezote.viajes.det_guia.sitio_destino.nombre,
          despachado_a: this.form.cabezote.viajes.det_guia.despachado_a,
        };
      }
    },

    buscarRemolques(search, loading) {
      if (search != "") {
        let me = this;
        me.cargando = true;
        loading(true);
        var url = "/api/admin/remolques/lista?placa=" + search;
        axios
          .get(url)
          .then(function (response) {
            let respuesta = response.data;
            me.listasForms.remolques = respuesta;
            me.cargando = false;
            loading(false);
          })
          .catch(function (error) {
            me.cargando = false;
            this.$swal({
              icon: "error",
              title: "Ocurrió un error: " + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    buscarEmpresas(search, loading) {
      this.listasForms.conductores = [];
      this.form.conductor = [];
      if (search != "") {
        let me = this;
        me.cargando = true;
        loading(true);
        var url = "/api/admin/empresas/lista?razon_social=" + search;
        axios
          .get(url)
          .then(function (response) {
            let respuesta = response.data;
            me.listasForms.empresas = respuesta;
            me.cargando = false;
            loading(false);
          })
          .catch(function (error) {
            me.cargando = false;
            this.$swal({
              icon: "error",
              title: "Ocurrió un error: " + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    buscarConductor(search, loading) {
      if (search != "") {
        let me = this;
        me.cargando = true;
        loading(true);
        var url = "/api/admin/conductores/lista?nombre=" + search;
        axios
          .get(url, {
            params: {},
          })
          .then(function (response) {
            let respuesta = response.data;
            me.listasForms.conductores = respuesta;
            me.cargando = false;
            loading(false);
          })
          .catch(function (error) {
            me.cargando = false;
            this.$swal({
              icon: "error",
              title: "Ocurrió un error: " + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    save() {
      if (!this.$v.form.$invalid) {
        let data = this.getData();
        this.cargando = true;

        axios({
          method: "PUT",
          url: "/api/hidrocarburos/inspecciones",
          data: data,
        })
          .then(async (response) => {
            if (response.data.msj) {
              this.$swal({
                icon: "error",
                title:
                  "La ultima inspección del  viaje se encuentra en estado borrador, se debe finalizar antes de crear otra. ",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
              this.cargando = false;
            } else {
              this.cargando = false;
              await this.inspeccionIndex(response.data.id);
              this.$swal({
                icon: "success",
                title:
                  "Los datos de la inspección se guardaron exitosamente...",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
            }
          })
          .catch((e) => {
            this.cargando = false;
            this.$swal({
              icon: "error",
              title: "Ocurrió un error, vuelva a intentarlo..." + e,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    getData() {
      // Se valida los datos para el formulario
      let tipoSitio = null;
      if (this.form.sitio_type == 1) {
        tipoSitio = "App\\Sitio";
      } else {
        tipoSitio = "App\\PuntoGestion";
      }

      // Se valida la fecha y hora de inicio de la insspección
      let fecha_inicio = this.form.fecha_inicio;
      let hora_inicio = this.form.hora_inicio;
      if (!this.form.fecha_inicio && !this.form.hora_inicio) {
        let ahora = new Date();
        let fecha = `${ahora.getFullYear()}-${
          ahora.getMonth() + 1
        }-${ahora.getDate()}`;
        let hora = `${ahora.getHours()}:${ahora.getMinutes()}:${ahora.getSeconds()}`;
        fecha_inicio = fecha;
        hora_inicio = hora;
      }

      if (this.entidad == "Postulacion") {
        this.form.det_postulacion_id = this.viajeInspeccion.id;
        this.form.viaje_id = null;
      } else {
        this.form.viaje_id = this.viajeInspeccion.id;
        this.form.det_postulacion_id = null;
      }

      let data = {
        id: this.form.id,
        det_postulacion_id: this.form.det_postulacion_id,
        viaje_id: this.form.viaje_id,
        formato_inspeccion_id: this.form.formato_inspeccion_id,
        sitio_id: this.form.sitio_id,
        empresa_id: this.form.empresa_id,
        conductor_id: this.form.conductor_id,
        vehiculo_id: this.form.vehiculo_id,
        sitio_type: tipoSitio,
        remolque_id: this.form.remolque_id,
        fecha_inicio,
        hora_inicio,
        fecha_fin: this.form.fecha_fin,
        hora_fin: this.form.hora_fin,
        observaciones: this.form.observaciones,
        responsable_id: this.responsable.id,
      };
      return data;
    },

    cambiaTab(tab) {
      this.tab = tab;
    },

    back() {
      this.$store.dispatch("getMenus", 2);
      this.$store.dispatch("getRoutes", this.$store.getters.getMenus);
      this.$store.dispatch("setRoutes");
      this.permisoLineaNegocio(2);
      return this.$router.replace("/Hidrocarburos/Inspecciones");
    },

    async inspeccionIndex(inspeccion_id) {
      await this.$store.dispatch("getMenus", 2);
      await this.$store.dispatch("getRoutes", this.$store.getters.getMenus);
      await this.$store.dispatch("setRoutes");
      this.permisoLineaNegocio(2);
      return this.$router.push({
        name: "/Hidrocarburos/InspeccionForm",
        params: {
          inspeccion_id: inspeccion_id,
          val: 0,
        },
      });
    },

    permisoLineaNegocio(linea_negocio) {
      let lineasUser = this.$store.state.user.lineas_negocio;
      return (
        lineasUser.find((linea) => linea.id === linea_negocio) !== undefined
      );
    },

    centralTraficoBack() {
      return this.$router.replace("/Admin/CentralTrafico");
    },
  },

  mounted() {
    this.getIndex();
    this.getSitioType();
    this.buscarSitios();
    this.buscarPuntosGestion();
  },
};
</script>
